export var getUnblockedAnswers = function (unblockingAnswers, hiddenAnswers) {
    if (unblockingAnswers === void 0) { unblockingAnswers = []; }
    if (hiddenAnswers === void 0) { hiddenAnswers = []; }
    return hiddenAnswers.filter(function (hidden) {
        return unblockingAnswers.some(function (unblocking) { return String(unblocking.unblocks_answer_id) === String(hidden.id); });
    });
};
export var getHiddenAnswer = function (answer, answers) {
    if (answers === void 0) { answers = []; }
    if (!answer.blocked_by_default)
        return false;
    var isUnblocked = answers.some(function (a) {
        return a.unblocks_answer_id &&
            a.answer_value &&
            String(a.unblocks_answer_id) === String(answer.id);
    });
    return !isUnblocked;
};
export var getAnswersWithValue = function (answers) {
    if (answers === void 0) { answers = []; }
    return answers.filter(function (i) { return i.answer_value; });
};
export var getNormalizeAnswers = function (answers) {
    if (!answers)
        return;
    return {
        allAnswersWithValue: getAnswersWithValue(answers),
        inheritAnswers: answers.filter(function (a) { return a.kind === 'inherit'; }),
        nonInheritAnswers: answers.filter(function (a) { return a.kind !== 'inherit'; }),
        hiddenAnswers: answers.filter(function (a) { return a.blocked_by_default; })
    };
};
export var getParsedAnswer = function (answers, isCheckbox) {
    return answers === null || answers === void 0 ? void 0 : answers.map(function (i) { return ({
        id: i.id,
        user_answer_value: isCheckbox ? i.title : i.answer_value
    }); });
};
